import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  data() {
    return{
      // authmenu: [],

      menuaccess: [],
      // authactionmenuselect: [],
      topickeywordsentiment_glob: [],
      topicsentiment_glob: [],//no
      jenis_parameter_glob:"",
      topic_glob:"",
      topic_glob2:"",
      selectedPeriode_glob:"",
      date_start_glob:"",
      date_end_glob:"",
      is_show_date_glob:"",
      sentiment_glob:"",
      ner_person_glob:"",
      ner_organization_glob:"",
      finalobjectfilterlogika_glob: "",
      data_source_glob: "",
      has_insert: "",
      bubble_data: [],
      collectionstore:[],
      collectionSelectstore:"",
      
    }
  },
  state: {
    navbarWithName: false,
    title: '',
    breadcrumbs: [],
    module: '',
    update: '',
    delete: '',
    insert: '',
    view: '',
  },
  mutations: {
    setNavbarWithName(state, value) {
      state.navbarWithName = value;
    },
    setModuleMenu (state, data_send) {
      // mulai generate breadcrumbs
      const breadcrumbs = [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        }
      ]

      // kumpulkan title yang ada
      const titles = [
        data_send.title,
        data_send.title2,
        data_send.title3
      ].filter(t => t) // buang yang kosong

      // push setiap title jadi breadcrumb
      titles.forEach((t, index) => {
        state.title = t
        breadcrumbs.push({
          text: t,
          disabled: false,
          href: `breadcrumbs_link_${index + 1}`,
        })
      })
      breadcrumbs[breadcrumbs.length - 1].disabled = true

      state.breadcrumbs = breadcrumbs
      state.titlePage = titles[titles.length - 1] || ''
      state.module = data_send.module
      state.update = data_send.update
      state.delete = data_send.delete
      state.insert = data_send.insert
      state.view = data_send.view

    },
    addButtonTmp (state, data_send){
      this.sentiment_glob = data_send.sentiment_glob
      this.ner_person_glob = data_send.ner_person_glob
      this.ner_organization_glob = data_send.ner_organization_glob
      this.finalobjectfilterlogika_glob = data_send.finalobjectfilterlogika_glob
      this.data_source_glob = data_send.data_source_glob
    },
    
    collectionactive (state, data_send) {
      if( data_send.collection_send !== '' &&  data_send.collection_send !== undefined){
        this.collectionstore=[];
        this.collectionstore = data_send.collection_send
      }
      this.collectionSelectstore =data_send.collection_select_send
    },
    addParameter (state, data_send) {
      this.jenis_parameter_glob="";
      this.topic_glob="";
      this.topic_glob2="";
      this.selectedPeriode_glob="";
      this.date_start_glob="";
      this.date_end_glob="";
      this.is_show_date_glob="";
      var topic2 =data_send.topic_glob2;
      if(data_send.topic_glob2 == undefined){
        topic2 ='';
      }
      this.jenis_parameter_glob = data_send.jenis_parameter_glob
      this.topic_glob = data_send.topic_glob
      this.topic_glob2 = topic2
      this.selectedPeriode_glob = data_send.selectedPeriode_glob
      this.date_start_glob = data_send.date_start_glob
      this.date_end_glob = data_send.date_end_glob
      this.is_show_date_glob = data_send.is_show_date_glob
      this.finalobjectfilterlogika_glob = data_send.finalobjectfilterlogika_glob
      this.data_source_glob = data_send.data_source_glob
    },
    addTopicKeyword (state, data_send) {
     this.topickeywordsentiment_glob = data_send.topickeywordsentiment_glob
   }
   
   ,menuGroup (state, data_send) {
    this.menuaccess = data_send.group
    }
    
   ,hasInsert (state, data_send) {
    this.has_insert = ""
    this.has_insert = data_send.insertact
    }
    ,dataBubble (state, data) {
      this.bubble_data=[];
      this.bubble_data = data.bubble_data
     }
    
   
  },
  getters: {
    // Getter to access navbarWithName
    navbarWithName: (state) => state.navbarWithName,
  },
  plugins: [createPersistedState()]
})
// console.log(store)
export default store;